import gql from "graphql-tag";

export default gql`
  query ($subject: MongoID) {
    contents(filter: { subject: $subject }, limit: 10000) {
      _id
      name
      type
      text
      duration
      doctype
      codeSlug
      contentGroup {
        _id
        name
      }
      carddescription
      texteditor {
        blocks
        entityMap
      }
      link
      expiredate
      statusActive
      public
      viewCount
      homeworkconfig {
        description {
          blocks
          entityMap
        }
        duedate
        exampleFile
        exampleFiletype
        typefile
      }
      homework {
        updatedAt
        _id
        status
        file
        filename
        submitdate
        student {
          _id
          firstname
          lastname
        }
      }
      surveyconfig {
        surveyQuestions {
          questions
        }
        description {
          blocks
          entityMap
        }
      }
    }
  }
`;
